import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

import {NotificationsState} from '@catcore/types/base';

const SUCCESS = 'success';
const INFO = 'info';
const WARN = 'warn';
const ERROR = 'error';

export const SeverityInfo = {
  SUCCESS, INFO, WARN, ERROR,
};

@Injectable()
export class NotificationsService {
  private messageSubject = new Subject<NotificationsState>();

  messageState = this.messageSubject.asObservable();

  log(summary, detail) {
    this.message(INFO, summary, detail, false);
  }

  error(summary, detail) {
    this.message(ERROR, summary, detail, true);
  }

  success(summary, detail) {
    this.message(SUCCESS, summary, detail, false);
  }

  warn(summary, detail) {
    this.message(WARN, summary, detail, true);
  }

  clear() {
    this.messageSubject.next({messages: []} as NotificationsState);
  }

  private message(severity, summary, detail, sticky) {
    this.messageSubject.next({messages: [{severity, summary, detail, sticky}]} as NotificationsState);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/services/notifications.service.ts